export enum OrderCustomerTypeEnum {
  PROFESSIONAL = 'PROFESSIONAL',
  INDIVIDUAL = 'INDIVIDUAL',
  SPECIFIC_LPC = 'SPECIFIC_LPC',
  SPECIFIC_PRO_OFFER = 'SPECIFIC_PRO_OFFER'
}
